'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hashQuery = undefined;

var _md = require('md5');

var _md2 = _interopRequireDefault(_md);

var _lodash = require('lodash.omit');

var _lodash2 = _interopRequireDefault(_lodash);

var _lodash3 = require('lodash.sortby');

var _lodash4 = _interopRequireDefault(_lodash3);

var _lodash5 = require('lodash.topairs');

var _lodash6 = _interopRequireDefault(_lodash5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var queryPart = function queryPart(searchQueryHash) {
  return searchQueryHash.indexOf('-') >= 0 ? searchQueryHash.split('-')[0] : searchQueryHash;
};

var formatDate = function formatDate(date) {
  return typeof date.getTime === 'function' ? date.getTime().toString().substring(6, 13) : '';
};

var hashQuery = exports.hashQuery = function hashQuery(query) {
  return (0, _md2.default)(JSON.stringify((0, _lodash4.default)((0, _lodash6.default)((0, _lodash2.default)(query, ['page', 'sortmode'])), function (item) {
    return item[0];
  })));
};

exports.default = function (_ref) {
  var _ref$date = _ref.date;
  var date = _ref$date === undefined ? new Date() : _ref$date;
  var query = _ref.query;
  var _ref$prevQueryId = _ref.prevQueryId;
  var prevQueryId = _ref$prevQueryId === undefined ? '' : _ref$prevQueryId;

  var newQueryHash = hashQuery(query);

  return newQueryHash === queryPart(prevQueryId) ? prevQueryId : newQueryHash + '-' + formatDate(date);
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/@seek/seek-jobs-analytics/build/utils/hashToUserQueryId.js
 ** module id = 411
 ** module chunks = 0
 **/